export default __webpack_public_path__ + "static/media/Alabora Orchard Type Rotary Tiller.542efc6c.png";